import * as actionTypes from "../../actions/actionTypes";

const initState = {
  datas: {},
  fetchDatasLoading: false,
  fetchDatasError: null,
  filtersLoading: false,
  filtersApplied: false,
  filtersReset: false,
};

const dashboardReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.DASHBOARD_DATAS_START:
      return {
        ...state,
        fetchDatasLoading: true,
      };
    case actionTypes.DASHBOARD_DATAS_SUCCESS:
      return {
        ...state,
        fetchDatasLoading: false,
        datas: { ...action.datas },
        filtersReset: false,
      };
    case actionTypes.DASHBOARD_DATAS_FAILED:
      return {
        ...state,
        fetchDatasLoading: false,
        fetchDatasError: action.err,
      };
    // FILTER
    case actionTypes.FILTER_DASHBOARD_START:
      return {
        ...state,
        filtersLoading: true,
      };
    case actionTypes.FILTER_DASHBOARD_SUCCESS:
      return {
        ...state,
        filtersLoading: false,
        filtersApplied: true,
      };
    case actionTypes.FILTER_DASHBOARD_RESET:
      return {
        ...state,
        filtersLoading: false,
        filtersApplied: false,
        filtersReset: true,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
